export default class Nestable {
    constructor(className, config = {}) {
    }
}
